import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
  ElementRef,
  HostListener,
} from '@angular/core';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import {
  NgbdSortableHeader,
  SortColumn,
  SortDirection,
  SortEvent,
} from './sortable.directive';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { LabelPolicyService, LabelPolicyStats, LabelPolicyUser } from 'src/app/_services/labelPolicy.service';
import { pickBy } from 'lodash';
import { IrmReport } from 'src/models/irmReport.model';
import { IrmLabel } from 'src/models/irmLabel.model';
import { CompanyService } from 'src/app/_services/company.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DatePeriodService } from 'src/app/_services/date-period.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupLimiteRegistrosComponent } from '../components/popup-limite-registros/popup-limite-registros.component';
import { PopupEtiquetasComponent } from './popup-etiquetas/popup-etiquetas.component';

@Component({
  selector: 'informes-irm',
  templateUrl: './informes-irm.component.html',
  styleUrls: ['./informes-irm.component.css'],
})
export class InformesIRMComponent implements OnInit, AfterViewInit {
  REPORTS: IrmReport[] = [];

  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  reports: IrmReport[];
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  isCountLoading = false;

  howAppliedTooltipVisible = false;

  toggleHowAppliedTooltip(event: MouseEvent) {
    event.stopPropagation();
    this.howAppliedTooltipVisible = !this.howAppliedTooltipVisible;
  }

  sortColumn: SortColumn;
  sortDirection: SortDirection;

  sortState: any;

  user: string;
  selectedActions: any[] = [];
  selectedDeptos: any[] = [];
  selectedLabels: any[] = [];
  minDate: any;
  maxDate: any;

  actions: string[] = [];
  labels: IrmLabel[] = [];
  labelsName: string[] = [];
  departments: string[] = [];

  areFiltersCollapsed = true;

  isLoading: boolean = true;

  filters: any;

  maxLength: number = 30;

  protected ngbModalRef: NgbModalRef;
  todasLasOpciones: [] = [];
  savedSortStr: any;

  // Pestañas
  currentTab = 1;

  // Directivas tab
  dpUsers: LabelPolicyUser[] = [];
  dpPage = 1;
  dpPageSize = 50;
  dpTotal = 0;
  dpIsLoading = false;
  dpIdentifier: string;
  dpDirectivas: string[] = [];
  dpEtiquetas: string[] = [];
  dpFuenteAsignacion: string;
  dpFuentes = ['Todos', 'Exchange directo', 'Grupo'];
  private dpCompanyId: number;
  private dpCompanyName: string = '';
  dpDirectivasOpciones: string[] = [];
  dpEtiquetasOpciones: string[] = [];
  dpSortBy = 'identifier';
  dpSortDir: 'asc' | 'desc' = 'asc';
  dpStats: LabelPolicyStats = null;
  dpStatsLoading = false;

  // tslint:disable-next-line: max-line-length
  constructor(
    private navService: NavService,
    private irmReportService: IrmReportService,
    private labelPolicyService: LabelPolicyService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private dataPeriodService: DatePeriodService,
    public router: Router,
    private modalService: NgbModal,
    private elementRef: ElementRef
  ) {
    Window['appuser'] = this;
  }

  @HostListener('document:click', ['$event'])
  closeHowAppliedTooltip(event: Event) {
    if (!this.howAppliedTooltipVisible) return;
    const tooltipElement = this.elementRef.nativeElement.querySelector(
      '[data-tooltip="howApplied"]'
    );
    if (!tooltipElement || !tooltipElement.contains(event.target as Node)) {
      this.howAppliedTooltipVisible = false;
    }
  }

  ngOnInit() {
    this.isLoading = true;
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);

    const quickCategoryDashboardEvent = window.sessionStorage.getItem(
      'quickCategoryDashboardEvent'
    );
    if (quickCategoryDashboardEvent) {
      const date = this.dataPeriodService.getDate();
      this.minDate = date.start;
      this.maxDate = date.end;
      this.selectedActions = ['LabelApplied', 'LabelChanged'];
      this.areFiltersCollapsed = false;
      window.sessionStorage.removeItem('quickCategoryDashboardEvent');
    } else {
      const savedFiltersStr =
        window.sessionStorage.getItem('informesIrmFilters');
      const savedSortStrItem = window.sessionStorage.getItem('informesIrmSort');
      if (savedSortStrItem) {
        this.savedSortStr = JSON.parse(savedSortStrItem);
      }
      if (savedFiltersStr) {
        this.areFiltersCollapsed = false;
        const savedFilters = JSON.parse(savedFiltersStr);
        this.user = savedFilters.user;
        this.selectedActions = savedFilters.selectedActions;
        this.selectedDeptos = savedFilters.selectedDeptos;
        this.selectedLabels = savedFilters.selectedLabels;
        this.minDate = savedFilters.minDate
          ? new Date(savedFilters.minDate)
          : this.minDate;
        this.maxDate = savedFilters.maxDate
          ? new Date(savedFilters.maxDate)
          : this.maxDate;
        this.sortState = savedFilters.sortState;
        this.sortColumn = savedFilters.sortColumn;
        this.sortDirection = savedFilters.sortDirection;

        if (
          this.user ||
          (this.selectedActions?.length ?? 0) > 0 ||
          (this.selectedDeptos?.length ?? 0) > 0 ||
          (this.selectedLabels?.length ?? 0) > 0
        ) {
          this.areFiltersCollapsed = false;
        } else {
          this.areFiltersCollapsed = true;
        }
      }
    }

    this.setFilters();
    this.getActions();
    this.getLabels();
    this.getDepartments();

    this.selectedNavItem({
      parent: 'record.report',
      child: 'record.cio',
      description: 'pageDescriptions.irm',
    });
  }

  ngAfterViewInit() {
    this.restoreSort();
    this.headers.changes.subscribe(() => {
      this.restoreSort();
    });
  }

  restoreSort() {
    if (this.sortColumn && this.sortDirection) {
      setTimeout(() => {
        const activeHeader = this.headers?.find(
          (h) => h.sortable === this.sortColumn
        );
        if (activeHeader) {
          activeHeader.direction = this.sortDirection;
        }
      });
    }
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = selectedDate.getFullYear().toString().substring(2);

    return `${day}.${month}.${year}`;
  }

  setFilters() {
    const filters = {
      mail: this.user,
      action:
        this.selectedActions?.length > 1
          ? [this.selectedActions]
          : this.selectedActions,
      department:
        this.selectedDeptos?.length > 1
          ? [this.selectedDeptos]
          : this.selectedDeptos,
      tag:
        this.selectedLabels?.length > 1
          ? [this.selectedLabels]
          : this.selectedLabels,
      dateBegin: this.minDate && this.formatDate(this.minDate),
      dateEnd: this.maxDate && this.formatDate(this.maxDate),
    };
    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports(true);
  }

  saveFiltersToSession() {
    const filtersToSave = {
      user: this.user,
      selectedActions: this.selectedActions,
      selectedDeptos: this.selectedDeptos,
      selectedLabels: this.selectedLabels,
      minDate: this.minDate,
      maxDate: this.maxDate,
      sortState: this.sortState,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    };
    window.sessionStorage.setItem(
      'informesIrmFilters',
      JSON.stringify(filtersToSave)
    );
  }

  cleanFilters() {
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);
    this.user = undefined;
    this.selectedActions = undefined;
    this.selectedDeptos = undefined;
    this.selectedLabels = undefined;
    this.filters = undefined;
    this.sortState = undefined;
    this.sortColumn = undefined;
    this.sortDirection = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports(true);
  }

  refreshReports(refetchCount: boolean = false) {
    this.isLoading = true;

    if (refetchCount) {
      this.isCountLoading = true;
      this.collectionSize = 0;
    }

    this.irmReportService
      .getAllIrmReports(this.page, this.pageSize, this.filters)
      .subscribe(
        (res) => {
          this.reports = res.body['results'];
          const embeddedTotal = res.body['total'];
          if (embeddedTotal > 0) {
            this.collectionSize = embeddedTotal;
            this.isCountLoading = false;
          } else if (this.isCountLoading) {
            const viewed = (this.page - 1) * this.pageSize + this.reports.length;
            const optimistic = this.reports.length === this.pageSize ? viewed + this.pageSize : viewed;
            if (optimistic > this.collectionSize) {
              this.collectionSize = optimistic;
            }
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.toastrService.error(error.error.message);
        }
      );

    if (refetchCount) {
      this.irmReportService.getIrmCount(this.filters).subscribe({
        next: (res) => {
          this.collectionSize = res.body['total'];
          this.isCountLoading = false;
        },
        error: () => {
          this.isCountLoading = false;
        },
      });
    }
  }

  getActions() {
    this.irmReportService.getActions().subscribe((res) => {
      this.actions = res.body;
    });
  }

  getLabels() {
    this.irmReportService.getLabels().subscribe((res) => {
      this.labels = res.body;
      this.labelsName = this.labels.map((label) => label.name);
    });
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  cargarMasOpciones() {
    const inicio = this.departments?.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  generateGeneralIrmReport() {
    if (this.collectionSize > 900000) {
      this.ngbModalRef = this.modalService.open(PopupLimiteRegistrosComponent, { size: 'lg', backdrop: 'static' });
      this.ngbModalRef.componentInstance.cantidadRegistros = this.collectionSize;
      this.ngbModalRef.result.then((result) => { if (result === 'continuar') this.reqIrmReport(); });
    } else {
      this.reqIrmReport();
    }
  }

  reqIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService.generateGeneralIrmReport(this.filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  generateEvoIrmReport() {
    if (this.collectionSize > 900000) {
      this.ngbModalRef = this.modalService.open(PopupLimiteRegistrosComponent, { size: 'lg', backdrop: 'static' });
      this.ngbModalRef.componentInstance.cantidadRegistros = this.collectionSize;
      this.ngbModalRef.result.then((result) => { if (result === 'continuar') this.reqEvoIrmReport(); });
    } else {
      this.reqEvoIrmReport();
    }
  }

  reqEvoIrmReport() {
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.irmReportService.generateEvoIrmReport(this.filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.saveFiltersToSession();
    this.refreshReports();
  }

  switchTab(tab: number) {
    this.currentTab = tab;
    if (tab === 1) {
      this.selectedNavItem({
        parent: 'record.report',
        child: 'record.cio',
        description: 'pageDescriptions.irm',
      });
    } else {
      this.selectedNavItem({
        parent: 'record.report',
        child: 'record.cio',
        grandchild: 'directives.tabName',
        description: 'pageDescriptions.directives',
      });
      if (this.dpUsers.length === 0) {
        this.loadDirectivas();
      }
    }
  }

  loadDirectivas() {
    this.dpIsLoading = true;
    this.companyService.getByUser().subscribe((res: any) => {
      this.dpCompanyId = res?.body?.id;
      this.dpCompanyName = res?.body?.name || res?.body?.Name || '';
      this.labelPolicyService.getOptions(this.dpCompanyId).subscribe(optRes => {
        this.dpDirectivasOpciones = optRes.body?.directivas ?? [];
        this.dpEtiquetasOpciones = optRes.body?.etiquetas ?? [];
      });
      this.loadStats();
      this.fetchDirectivas();
    });
  }

  loadStats() {
    this.dpStatsLoading = true;
    this.labelPolicyService.getStats(this.dpCompanyId).subscribe({
      next: (res) => {
        this.dpStats = res.body;
        this.dpStatsLoading = false;
      },
      error: () => { this.dpStatsLoading = false; }
    });
  }

  fetchDirectivas() {
    if (!this.dpCompanyId) return;
    this.dpIsLoading = true;
    const filters = {
      identifier: this.dpIdentifier,
      directivas: this.dpDirectivas,
      fuenteAsignacion: this.dpFuenteAsignacion,
      etiquetas: this.dpEtiquetas,
    };
    this.labelPolicyService.getUsers(this.dpCompanyId, filters, this.dpPage, this.dpPageSize, this.dpSortBy, this.dpSortDir)
      .subscribe({
        next: (res) => {
          this.dpUsers = res.body.results;
          this.dpTotal = res.body.total;
          this.dpIsLoading = false;
        },
        error: () => { this.dpIsLoading = false; }
      });
  }

  openEtiquetasModal(user: LabelPolicyUser) {
    const etiquetas = user.etiquetas
      ? [...new Set(user.etiquetas.split(',').map(e => e.trim()).filter(e => e))]
      : [];
    const modalRef = this.modalService.open(PopupEtiquetasComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
      size: 'lg',
    });
    modalRef.componentInstance.etiquetas = etiquetas;
    modalRef.componentInstance.identifier = user.identifier;
    modalRef.result.then();
  }

  downloadDirectivas() {
    const filters = {
      identifier: this.dpIdentifier,
      directivas: this.dpDirectivas,
      fuenteAsignacion: this.dpFuenteAsignacion,
      etiquetas: this.dpEtiquetas,
    };
    this.labelPolicyService.exportExcel(this.dpCompanyId, filters, this.translate.currentLang).subscribe({
      next: (res) => {
        const blob = res.body;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const safeName = this.dpCompanyName.replace(/[^a-zA-Z0-9_\-áéíóúÁÉÍÓÚñÑ ]/g, '').trim();
        const namePart = safeName ? `${safeName}_` : '';
        a.download = `Directivas_${namePart}${new Date().toISOString().slice(0, 10)}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => this.toastrService.error(this.translate.instant('errorReport'))
    });
  }

  sortDpBy(col: string) {
    if (this.dpSortBy === col) {
      this.dpSortDir = this.dpSortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.dpSortBy = col;
      this.dpSortDir = 'desc';
    }
    this.dpPage = 1;
    this.fetchDirectivas();
  }

  applyDirectivasFilters() {
    this.dpPage = 1;
    this.fetchDirectivas();
  }

  cleanDirectivasFilters() {
    this.dpIdentifier = undefined;
    this.dpDirectivas = [];
    this.dpFuenteAsignacion = undefined;
    this.dpEtiquetas = [];
    this.dpPage = 1;
    this.fetchDirectivas();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  seeDetails(id) {
    this.router.navigate([`home/informes/FilesControl/${id}`]);
  }
}
